<template>
    <div class="question-box" @click="handleMouseEnterOpen">
        <game-description
            v-if="$store.state.editGameConfig &&
                    $store.state.editGameConfig.question &&
                    $store.state.editGameConfig.question.description &&
                    !$store.state.editGameConfig.question.description.isHide
                "
            :enabled.sync="$store.state.editGameConfig.question.description.enabled"
            :text.sync="$store.state.editGameConfig.question.description.text"
            @onDescription="onDescription"
        />
        <p
            v-if="this.$store.state.editGameConfig && !$store.state.editGameConfig.question.header.isHide"
            class="btn"
            @click="handleAdd"
        >
            <span class="add">+</span><span class="name">{{this.$store.state.editGameConfig && $store.state.editGameConfig.question.header.title}}</span>
        </p>
        <el-tree
                ref="tree"
                class="tree-box treeGaneEdit"
                :data="newForm"
                node-key="__trimPathById"
                :props="defaultProps"
                :default-expanded-keys="curExpandeds"
                :expand-on-click-node="false"
                @node-click="nodeClick"
                @node-collapse="nodeCollapse"
                @node-expand="nodeExpand"
                @click="handleMouseEnterOpen"
        >
            <div class="custom-tree-row custom-tree-node"
                 slot-scope="{ node, data }"
                 :class="{'hightLight': curHighLignt.includes(data.__trimPathById)}"
            >
                <span
                    class="label"
                    :style="`margin-left: ${any2Number(data.marginLeft)}px;width:${any2Number(data.titleWidth)}px;`"
                >{{ data.title }}</span>
                <div class="row-box">
                    <div
                        class="row"
                        :class="{isHide: item.isHide, isEmpty: item.type === 'Empty'}"
                        :style="`width:${any2Number(item.width)}px;`"
                        v-for="(item, index) in data.components"
                        :key="index"
                    >
                        <span
                            v-if="item.type === 'InputNumber' && !item.iconHide"
                            class="icon-box"
                            :class="{disabled: item.alwaysEnabled}"
                            @click="onBtnsPre(item.alwaysEnabled, data, { parentId: index, ObjectKeyValue: {key: 'enabled', value: !item.enabled} })"
                        >
                            <span v-if="item.enabled" class="iconfont icon-xianshi"></span>
                            <span v-else class="disabled iconfont icon-yincang"></span>
                        </span>
                        <p
                           v-if="item.type !== 'SelectList'"
                           :style="`margin-left: ${any2Number(item.marginLeft)}px;width: ${any2Number(item.titleWidth)}px`"
                           class="name"
                        >{{item.title}}</p>
                        <div v-if="item.type === 'Btns'">
                            <Btns
                                :form.sync="item.buttons"
                                @onBtns="onBtns(data,{parentId:index, ...$event, parentItem: item})"
                            />
                        </div>
                        <div class="radio-box" v-else-if="item.type === 'Switch'">
                            <div
                                v-if="item.icon === 'word'"
                                class="other-box">
                                <p v-if="item.value"
                                   class="img-box active"
                                   @click.stop="onBtns(data, { parentId: index, ...item, value: false })"
                                ><span class="iconfont icon-wenzi1"></span></p>
                                <p
                                   v-else
                                   class="img-box"
                                   @click.stop="onBtns(data, { parentId: index, ...item, value: true })"
                                ><span class="iconfont icon-wenzijinyong"></span></p>
                            </div>
                            <div
                                v-else-if="item.icon === 'image'"
                                class="other-box">
                                <p
                                   v-if="item.value"
                                   class="img-box active"
                                   @click.stop="onBtns(data, { parentId: index, ...item, value: false })"
                                ><span class="iconfont icon-tupiangaoliang"></span></p>
                                <p
                                   v-else
                                   class="img-box"
                                   @click.stop="onBtns(data, { parentId: index, ...item, value: true })"
                                ><span class="iconfont icon-tupianjinyong"></span></p>
                            </div>
                            <div
                                v-else
                                class="radio-boxs">
                                <el-radio
                                        v-model="item.value"
                                        :label="true"
                                        @click.native.stop="onBtns(data, { parentId: index, ...item, value: true })"
                                >是</el-radio>
                                <el-radio
                                        v-model="item.value"
                                        :label="false"
                                        @click.native.stop="onBtns(data, { parentId: index, ...item, value: false })"
                                >否</el-radio>
                            </div>
                        </div>
                        <div class="input-number-box" v-else-if="item.type === 'InputNumber'">
                            <el-input-number
                                    v-model="item.value"
                                    v-bind="item"
                                    size="small"
                                    placeholder="请输入"
                                    @focus="handleMouseEnterOpen"
                                    @change="onBtns(data, { parentId: index, ...item, oneWay: true })"
                            >
                            </el-input-number>
                            <input v-model="item.value"
                                   class="input-new"
                                   type="text"
                                   @focus="handleMouseEnterOpen"
                                   @input="onBtns(data, { parentId: index, ...item, value: item.value>99?99:str2Number(item.value), oneWay: true })"
                                   @blur="setSendKeyBoardToCocos({key: 'inputText', value: false})"
                            >
                        </div>
                        <div v-else-if="item.type === 'Input'">
                            <el-input
                                    v-model="item.value"
                                    v-bind="item"
                                    size="small"
                                    placeholder="请输入内容"
                                    @input="onBtns(data, { parentId: index, ...item })"
                                    @focus="onFocus(data, { parentId: index, ...item, type: 'focus' })"
                                    @click="handleMouseEnterOpen"
                            ></el-input>
                        </div>
                        <div v-else-if="[
                            'TextInput',
                            'AudioSelect',
                            'ImageSelect',
                            'VideoSelect',
                            'BackgroundSelect',
                            'AnimationSelect',
                            'AudioWord'
                        ].includes(item.type)">
                            <CommonComp
                                v-bind.sync="item"
                                :parentId="data.__trimPathById"
                                :index="index"
                                @onBtns="onBtns(data,{parentId: index, ...$event})"
                                @focus="onBtns(data, { parentId: index, ...$event })"
                                @click="handleMouseEnterOpen"
                            />
                        </div>
                        <div class="radio-box" v-else-if="item.type === 'OnOrOff'">
                            <div
                                    v-if="item.icon === 'word'"
                                    class="other-box">
                                <p v-if="item.value"
                                   class="img-box active"
                                   @click.stop="onBtns(data, { parentId: index, ...item, value: false })"
                                ><span class="iconfont icon-wenzi1"></span></p>
                                <p
                                        v-else
                                        class="img-box"
                                        @click.stop="onBtns(data, { parentId: index, ...item, value: true })"
                                ><span class="iconfont icon-wenzijinyong"></span></p>
                            </div>
                            <div
                                    v-else-if="item.icon === 'image'"
                                    class="other-box">
                                <p
                                        v-if="item.value"
                                        class="img-box active"
                                        @click.stop="onBtns(data, { parentId: index, ...item, value: false })"
                                ><span class="iconfont icon-tupiangaoliang"></span></p>
                                <p
                                        v-else
                                        class="img-box"
                                        @click.stop="onBtns(data, { parentId: index, ...item, value: true })"
                                ><span class="iconfont icon-tupianjinyong"></span></p>
                            </div>
                            <div
                                v-else
                                class="radio-boxs">
                                <span
                                        v-if="item.value"
                                        class="iconfont icon-xuanzhong"
                                        @click.stop="onBtns(data, { parentId: index, ...item, value: false })"
                                ></span>
                                <span
                                        v-else
                                        class="iconfont icon-weixuanzhong"
                                        @click.stop="onBtns(data, { parentId: index, ...item, value: true })"
                                ></span>
                            </div>
                        </div>
                        <div class="justify-box" v-else-if="item.type === 'Justify'">
                            <span class="icon-type">
                                <span
                                    class="iconfont icon-duiqi"
                                    @click.stop="onBtns(data, { parentId: index, ...item, value: !item.value })"
                                ></span>
                            </span>
                        </div>
                        <div v-else-if="item.type === 'SelectList'">
                            <SelectList
                                :title.sync="item.title"
                                :form.sync="item.options"
                                :value.sync="item.value"
                                @onBtns="onBtns(data,{parentId:index, ...$event})"
                            />
                        </div>
                        <div v-else-if="item.type === 'Empty'">
                            <p :style="`width:${any2Number(item.width)}px`"></p>
                        </div>
                    </div>
                </div>
            </div>
        </el-tree>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import GameDescription from './components/gameDescription'
    import CommonComp from './components/commonComp'
    import SelectList from './components/selectList'
    import Btns from '../../../../../../../../components/RowBox/components/Btns'
    import { AudioPause } from "../../../../../../../../utils/audio";
    export default {
        name: "Question",
        components: {
            GameDescription,
            CommonComp,
            Btns,
            SelectList
        },
        props: {
            form: Object,
            // 展开id集
            expandeds: Array
        },
        computed: {
            globalPlaying(){
                return this.$store.state.editGameConfig && this.$store.state.editGameConfig.audio
            },
            config(){
                return this.$store.state.editGameConfig
            },
            // 正在高亮的行
            curHighLignt(){
                let list = []
                try {
                    const items = this.highLight
                    for (let item in items){
                        list.push(parseInt(item))
                    }
                }catch (e) {
                    console.log('获取正在高亮行的id集合失败==>', e)
                }
                return list
            },
            // 判断是否存在二级行数
            isLeaf(){
                let state = false
                try {
                    this.newForm.map( v => {
                        if (v.childrens) state = true
                    })
                }catch (e) {
                    console.log('等待判断是否有二级行数')
                }
                return state
            },
            // 获取当前选项的unique
            curUnique(){
                let unique = Math.random()
                try {
                  let arr = this.$store.state.menusData.lessonSelected
                    arr = arr.split('/')
                    unique = this.$store.state.menusData.blocksForm[arr[0]].children[arr[1]].unique
                } catch (e) {
                    console.log('获取失败1')
                }
                return unique
            }
        },
        watch: {
            expandeds: {
                handler(vl){
                    this.curExpandeds = vl
                },
                deep: true,
                immediate: true
            },
            curExpandeds: {
                handler(vl){
                    this.$emit('update:expandeds', vl)
                },
                deep: true,
                immediate: true
            },
            // 监听高亮行 变化
            curHighLignt:{
                handler(newData, oldData){
                    if(JSON.stringify(oldData)!==JSON.stringify(newData)){
                        this.updateHighLightRow()
                    }
                },
                deep: true,
                immediate: true
            },
            curUnique: {
              handler(){
                  // this.isShow = false
                  try {
                      // let fn = setTimeout(()=>{
                          // this.isShow = true
                          // console.log('7771==>', this.$store.state.editGameConfig.question)
                          this.$store.state.editGameConfig &&
                          this.$store.state.editGameConfig.question &&
                          this.setNewForm(this.$store.state.editGameConfig.question)
                      //     clearTimeout(fn)
                      // })
                  } catch (e) {
                      console.log('等待刷新配置==>', e)
                  }
              },
              deep: true,
              immediate: true
            },
            '$store.state.editGameConfig': {
                handler(vl){
                    this.$nextTick(()=>{
                        try {
                            // if(vl && oldData &&  JSON.stringify(vl.question) !== JSON.stringify(oldData.question)) {
                            console.log('7772==>', vl && vl.question)
                            vl && vl.question && this.setNewForm(vl.question)
                            // }
                            if (vl && vl.selection && vl.selection.content){
                                this.highLight = vl.selection.content
                            }
                            // 获取行最大 然后每行都是最长宽度
                            const fn = setImmediate(()=>{
                                this.calcRow()
                                clearImmediate(fn)
                            })
                        }catch (e) {
                            console.log('报错==>', e)
                        }
                    })
                },
                deep: true,
                immediate:true
            },
            globalPlaying: {
                handler(newData, oldData){
                    try {
                        const newData1 = newData && this.$_.cloneDeepWith(newData)
                        const newData2 = oldData && this.$_.cloneDeepWith(oldData)
                        console.log('retro1119-0', newData1, newData2)


                        if(!newData1.playing && newData2.playing){
                            AudioPause()
                            return false
                        }

                        let oneData = newData1 && this.$_.cloneDeepWith(Object.values(newData1.playing))
                        let twoData = newData2 && this.$_.cloneDeepWith(Object.values(newData2.playing))
                        setTimeout(()=>{
                            // 如果两个播放按钮的绝对路径不一致 删除旧的播放按钮状态
                            try {
                                console.log('retro1119-1',oneData, twoData)
                                const state = oneData[0].absolutePath !== twoData[0].absolutePath
                                console.log('retro1119-2',state)
                                if(state) {
                                    let rowItem = twoData[0]
                                    let id = rowItem.rowId
                                    let path = rowItem.componentPath + '/status'
                                    let data = 'on'
                                    let operation = 'REPLACE'
                                    const operationQueue = [{id, path, data, operation, oneWay: false}]
                                    this.setOperationQueue(operationQueue)
                                    console.log('retro1119-3',this, operationQueue)
                                }
                            } catch (e) {
                              console.log('删除旧的正在播放状态', e)
                            }
                        },300)

                        console.log('retro1119-4',newData1.playing, newData2.playing, !newData1.playing && newData2.playing)
                    } catch (e) {
                        console.log('判断失败==>', e)
                    }
                },
                deep: true,
                immediate: false
            },
            '$store.state.menusData.lessonSelected': {
                handler(newValue, oldValue){
                    if(newValue !== oldValue) {
                        this.selectArr = []

                        this.isShow = false
                        let fn = setTimeout(()=>{
                            this.isShow = true
                            clearTimeout(fn)
                        })
                    }
                },
                deep: true,
                immediate:false
            }
        },
        mounted(){
            this.$nextTick(()=>{
                // 初始加载展开所有题目 当expandeds为null表示初始状态，否则表示被修改
                if(!Array.isArray(this.expandeds)) this.expandedAll({data: this.newForm})
            })
        },
        data () {
            return {
                initial: true, // 初始状态
                isShow: true,
                curExpandeds: this.expandeds, // 当前展开的id集
                curSelectId: '', // 当前选中id
                newForm: [],
                // 展开列表
                selectArr: [],
                defaultProps: {
                    children: 'childrens',
                    label: 'title'
                },
                highLight: {},
                nextEvent: null // 下一步执行事件
            }
        },
        methods: {
            ...mapActions(['setOperationQueue', 'setSendKeyBoardToCocos']),
            str2Number(str){
                let num = str
                if(typeof str === 'string'){
                 if(str === ''){
                     return 1
                 }
                 try {
                     num = parseInt(str)
                 } catch (e) {
                     console.log('字符串转数字失败==>', e)
                     num = 0
                 }
                }
                return num
            },
            onFocus(rowData, editItem){
                this.setSendKeyBoardToCocos({key: 'inputText', value: false})
                this.onBtns(rowData, editItem)
            },
            onBlur(rowData, editItem){
                this.setSendKeyBoardToCocos({key: 'inputText', value: true})
                this.onBtns(rowData, editItem)
            },
            // 任意字符转数字
            any2Number(value){
                let newValue = value
                try {
                    newValue = parseInt(newValue)
                } catch (e) {
                  console.log('转成数字失败==>', e)
                }
                return newValue
            },
            // 获取最大的行宽度
            calcRow(){
                let divs = document.querySelectorAll('.treeGaneEdit .el-tree-node__content')
                let newDivs = Array.from(divs)
                let width = 0
                newDivs.map(v=>{
                    let temWidth = 0
                    if(v.children[0] && v.children[0].clientWidth)temWidth += v.children[0].clientWidth
                    if(v.children[1] && v.children[1].clientWidth)temWidth += v.children[1].clientWidth
                    if(v.children[2] && v.children[2].clientWidth)temWidth += v.children[2].clientWidth
                    if(temWidth>width)width = temWidth
                    console.log(width)
                })
                if(width>0){
                    let newWidth =width + 300 + 'px'
                    let description = document.querySelector('.game-description')
                    if(description)description.style.width = newWidth

                    let btn = document.querySelector('.question-box>.btn')
                    if(btn)btn.style.width = width + 298 + 'px'

                    let nodes = document.querySelectorAll('.treeGaneEdit .el-tree-node')
                    for(let i = 0, len=nodes.length; i<len; i++){
                        nodes[i].style.width = newWidth
                    }
                }
            },
            // 展开所有题目
            expandedAll({data}){
                if(this.curExpandeds === null){
                    this.curExpandeds = []
                }
                data.map(v=>{
                    if(v.childrens && v.childrens.length>0){
                        if(!this.curExpandeds.includes(v.__trimPathById))this.curExpandeds.push(v.__trimPathById)
                        this.expandedAll({data: v.childrens})
                    }
                })
            },
            // 取消所有高亮
            clearHighLight(){
                this.highLight = {}
            },
            // 更新高亮行
            updateHighLightRow(){
                // 1.先清除所有类名custom-tree-node 父级中的 hightLightRow
                // 2.判断子行是否存在 类名 hightLight
                // 3.如果存在，继续判断它的父节点是否存在 类名 hightLightRow
                // 4.给自己存在类名hightLight的父级加上 类名 hightLightRow
                this.$nextTick(()=>{
                    let divs = document.querySelectorAll('.custom-tree-row')
                    if(Array.from(divs) && Array.from(divs).length>0){
                        Array.from(divs).map(v=>{
                            v.parentNode.classList.remove('hightLightRow')
                            if(v.classList.contains('hightLight')){
                                v.parentNode.classList.add('hightLightRow')
                            }
                        })
                    }
                })
            },
            currentChange(data, node){
              console.log('currentChange==>', data, node)
            },
            nodeExpand(data, node, target){
              console.log('nodeExpand==>', data, node, target)
                // 1.如果不存在id 往选中id集加id
                const id = data.__trimPathById
                if(!this.curExpandeds.includes(id)){
                    // 1.获取当前id节点
                    // 2.当前id及底下所有的字集id
                    // 3.将当前id集添加到所展开的id集 并去重
                    const curNodes = this.$utils.getCurNode({id: id, data: this.newForm})
                    const addIds = this.$utils.getIdsByNode({node: curNodes})
                    const curIds =  this.$utils.addIds({addIds, ids: this.curExpandeds})

                    this.curExpandeds = curIds
                }
            },
            nodeCollapse(data, node, target){
              console.log('nodeCollapse==>', data, node, target)
                const id = data.__trimPathById
                let index = this.curExpandeds.indexOf(id)
                // 1.如果存在id 从id集删除
                if(index>-1) {
                    // 1.获取当前id节点
                    // 2.当前id及底下所有的字集id
                    // 3.删除当前id集存在2的id
                    const curNodes = this.$utils.getCurNode({id: this.curExpandeds[index], data: this.newForm})
                    const deleteIds = this.$utils.getIdsByNode({node: curNodes})
                    const curIds =  this.$utils.deleteIds({deleteIds, ids: this.curExpandeds})

                    this.curExpandeds = curIds
                }
            },
            nodeClick(data, node){
                console.log(data, node)
                if(this.$utils.isFastExecute(300)){
                    return false
                }
                console.log('node==>', node, data, data.childrens, this.$store.state.timestamp)
                // debugger
                // if(!Array.isArray(data.childrens)){
                //     this.curSelectId = data.__trimPathById
                // }

                // 1.记住历史选中
                // 2.删除当前选中
                // 3.添加新选中
                // let oldHight = this.curHighLignt
                let operationQueue = []
                // if(this.curHighLignt && this.curHighLignt.length>0){
                //     operationQueue.push({
                //         path: `/selection/content/${oldHight[0]}`,
                //         operation: 'DELETE',
                //         oneWay: true
                //     })
                // }
                //
                operationQueue.push({
                    path: `/selection/content`,
                    operation: 'REPLACE',
                    data: {
                        [data.__trimPathById]: null
                    },
                    oneWay: true
                })

                this.$store.state.editGameConfig.selection.content = {
                    [data.__trimPathById]: null
                }

                this.setOperationQueue(operationQueue)

                const fn = setTimeout(()=>{
                    if(this.nextEvent){
                        this.nextEvent()
                        this.nextEvent = null
                    }
                    clearTimeout(fn)
                }, 500)
            },
            tableRowClassName({row}) {
                if (row.focus) {
                    return 'focus';
                }
                return '';
            },
            expandChange(expandedRows, expanded){
                console.log('expand==>', expandedRows, expanded)
                if(expanded && expanded.length>0){
                    // 展开
                    let index = this.selectArr.indexOf(expandedRows.index)
                    if(index === -1) this.selectArr.push(expandedRows.index)
                } else {
                    // 收缩
                    let index = this.selectArr.indexOf(expandedRows.index)
                    if(index > -1) this.selectArr.splice(index, 1)
                }
            },
            setNewForm(obj) {
                let data = this.$_.cloneDeepWith(obj.menu)
                if (!Array.isArray(obj.menu)) {
                    let list = []
                    Object.values(obj.menu).map((v,i)=>{
                        let newObj = {...Object.values(obj.menu)[i], index: Object.keys(obj.menu)[i]}
                        if(v.childrens){
                            // 对象转成数组
                            newObj.childrens = this.getNewChilrens({data: v.childrens}) //this.newSort(this.$_.values(v.childrens))
                        }
                        list.push(newObj)
                    })
                    list = this.newSort(list)
                    data = list
                }
                this.newForm = this.newSort(data)

                // 初始加载展开所有题目 当expandeds为null表示初始状态，否则表示被修改
                if(this.initial && (!Array.isArray(this.expandeds) || !this.expandeds.length)) {
                    this.expandedAll({data: this.newForm})
                    this.initial = false
                }

                // this.$nextTick(()=>{
                // })
            },
            // 将子列表为对象的全部转成数组
            getNewChilrens({data}){
                if (!Array.isArray(data)) {
                    let list = []
                    Object.values(data).map((v,i)=>{
                        let newObj = {...Object.values(data)[i], index: Object.keys(data)[i]}
                        if(v.childrens){
                            // 对象转成数组
                            newObj.childrens = this.getNewChilrens({data: v.childrens})
                        }
                        list.push(newObj)
                    })
                    list = this.newSort(list)
                    data = list
                }
                return data
            },
            // 对表格重新排序
            newSort(data) {
                let newData = data
                newData = newData.sort((a,b)=>{
                    return b.priority - a.priority
                })
                // console.log(newData)
                // debugger
                return newData
            },
            // 提交时判断数值组件是否支持
            onBtnsPre(state, rowData, editItem){
                if(state){
                    return false
                }
                this.onBtns(rowData, editItem)
            },
            /***
             * 行回调时间
             * @param rowData 当前行数据
             * @param editItem 当前行内编辑数据
             */
            onBtns(rowData, editItem){
                this.handleMouseEnterOpen();
                console.log('onBtns==>',rowData, editItem)
                // if(this.$utils.isFastExecute(100)){
                //     return false
                // }
                this.nextEvent = ()=> {
                    console.log('按钮点击22==>', rowData, JSON.parse(JSON.stringify(editItem)))
                    let id = rowData.__trimPathById
                    let path = ''
                    let newPath = ''
                    let data = ''
                    let operation = 'REPLACE'
                    let oneWay = editItem?.oneWay || false

                    if (editItem.parentItem) {
                        // 当前类型为btns
                        operation = 'TRIGGER'
                        data = editItem.item.event
                        path = `/components/${editItem.parentId}/buttons/${editItem.index}/event`
                        newPath = `/components/${editItem.parentId}/buttons/${editItem.index}`
                    } else {
                        // 自定义修改某可字段的key
                        if (editItem.ObjectKeyValue) {
                            data = editItem.ObjectKeyValue.value
                            path = `/components/${editItem.parentId}/${editItem.ObjectKeyValue.key}`
                            newPath = `/components/${editItem.parentId}`
                        } else {
                            if (typeof editItem.value === 'boolean') {
                                data = editItem.value
                            } else {
                                data = editItem.value
                            }
                            path = `/components/${editItem.parentId}/value`
                            newPath = `/components/${editItem.parentId}`
                        }
                    }

                    // console.log('id, path, data, operation', id, path, data, operation)
                    const isFocus = editItem.type === 'focus'

                    const operationQueue = []
                    if(isFocus) operationQueue.push({id, path: newPath + '/focus', data: null, operation: 'REFRESH', oneWay: true})
                    if(!isFocus){
                        let obj = {id, path, data, operation, oneWay}
                        if(editItem?.oneWay)obj.oneWay = editItem?.oneWay
                        operationQueue.push(obj)
                    }

                    this.setOperationQueue(operationQueue)
                }
                const fn = setTimeout(()=>{
                    if(this.nextEvent){
                        this.nextEvent()
                        this.nextEvent = null
                        clearTimeout(fn)
                    }
                }, 300)
            },
            handleAdd () {
                console.log('新增题目数==>', this.$store.state.editGameConfig.question)
                const operationQueue = [{path: '/question/header/event', data: this.$store.state.editGameConfig.question.header.event, operation: 'TRIGGER'}]
                this.setOperationQueue(operationQueue)
            },
            onDescription (newData, editItem) {
                console.log('修改游戏说明==>', data)
                let path = `/question/description/text`
                let data = newData

                if(editItem && editItem.ObjectKeyValue){
                    path = `/question/description/${editItem.ObjectKeyValue.key}`
                    data = editItem.ObjectKeyValue.value
                }
                const operationQueue = [{path, data, operation: 'REPLACE', oneWay: !editItem}]
                this.setOperationQueue(operationQueue)
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        }
    }
</script>
<style>
    .el-table__expanded-cell[class*=cell]{
        padding: 0px !important;
        border-bottom: none !important;
    }
    .el-tree-node__content.hightLightRow{
        background-color: #E4E7ED !important;
    }
    .question-box .el-tree-node.is-current.is-focusable>.el-tree-node__content .custom-tree-node{
        color: #606266;
    }
</style>
<style lang="scss" scoped>
.tree-box /deep/ .el-tree-node__children{
    overflow: initial !important;
}
.game-table /deep/ .focus{
    background-color: #E4E7ED;
}
.question-box /deep/ .el-tree-node{
    min-width: 100%;
}
.question-box /deep/ .el-tree-node__content{
    height: initial !important;
    transition: all .2s linear;
    background: #F0F2F5;
    border-radius: 4px;
    margin-bottom: 4px;
}
.question-box /deep/ .el-tree-node__content:hover{
    background-color: #E4E7ED !important;
}
.question-box /deep/ .el-tree-node.is-current.is-focusable > .el-tree-node__content{
    background-color: #E4E7ED !important;
}
.question-box /deep/ span.el-tree-node__expand-icon.el-icon-caret-right{
    margin-left: 8px;
    margin-right: 12px;
}
.question-box /deep/ span.el-tree-node__expand-icon.el-icon-caret-right:after{
    content: '';
    display: inline-block;
    position: absolute;
    left: -1px;
    top: -1px;
    width: 32px;
    height: 32px;
    background-color: white;
    z-index: -1;
    border-radius: 4px;
    transition: transform .3s ease-in-out;
}
.question-box /deep/ span.el-tree-node__expand-icon.el-icon-caret-right:hover:after{
    background-color: rgba(255,255,255,.8);
}
.question-box /deep/ span.el-tree-node__expand-icon.el-icon-caret-right:before{
    font-size: 18px;
    color: #303133;
}
.question-box /deep/ span.el-tree-node__expand-icon.el-icon-caret-right.expanded:after{
    transform: rotate(-90deg);
}
.question-box /deep/ span.el-tree-node__expand-icon.el-icon-caret-right.is-leaf:before{
    display: none;
}
.question-box /deep/ span.el-tree-node__expand-icon.el-icon-caret-right.is-leaf:after{
    display: none;
}
.question-box{
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    min-width: 860px;

    .titles{
        display: flex;
        flex-direction: row;
        height:30px;
        background: #F5F7FA;
        margin-top: 16px;

        .title{
            font-size: initial;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: normal;
            word-break: break-all;
            line-height: 30px;
            color: #909399;
            font-size: 14px;

            &.one{
                padding: 0px;
                padding-left: 24px;
                width: 180px;
            }
        }
    }
    .custom-tree-node{
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 48px;

        & /deep/ .el-tree-node__content{
            height: initial;
        }

        .label{
            margin-right: 14px;
            font-size: 14px;
        }
    }

    .table-expand{

    }

    .btn {
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        border: 1px dotted #C0C4CC;
        font-size:14px;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:32px;
        text-align: center;
        cursor: pointer;
        user-select: none;
        background-color: #F5F7FA;
        margin-bottom: 8px;
        min-width: calc(100% - 2px);

        &:hover{
            opacity: .9;
        }
        &:active{
            opacity: .6;
        }

        .add{
            margin-right: 6px;
            font-size: 20px;
        }
    }
}
.row-box{
    display: flex;

    .row{
        font-size: 14px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 20px;
        flex-shrink: 0;

        .input-number-box{
            position: relative;

            .input-new{
                position: absolute;
                top: 11px;
                left: 34px;
                border: none;
                outline: none;
                width: 62px;
                height: 28px;
                text-align: center;
                color: #606266;
            }
        }

        .icon-box {
            width: 30px;
            height: 30px;
            background: #FFFFFF;
            border-radius: 4px;
            text-align: center;
            line-height: 32px;
            flex-shrink: 0;
            margin-right: 8px;

            .icon-xianshi{
                font-size: 12px;
            }

            .disabled {
                color: #A8AAAD;
                cursor: initial;
            }
        }

        .justify-box{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;

            .icon-type{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;

                .iconfont{
                    color: white;
                    font-size: 32px;
                }
            }
        }

        &.isHide{
            display: none;
        }

        &.isEmpty{
            margin-right: 0px;
        }

        .name{
            margin-right: 10px;
        }

        .radio-box {

            .other-box{
                .img-box{
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    border: 1px solid #A8AAAD;
                    text-align: center;

                    .iconfont{
                        font-size: 16px;
                        color: #A8AAAD;
                    }

                    &.active{
                        border-color: #303133;

                        .iconfont{
                            color: #303133;
                        }
                    }
                }
            }

            .iconfont{
                font-size: 24px;
            }

            .icon-weixuanzhong{
                color: white;
            }
            /deep/ .el-radio{
                margin-right: 0px;
                margin-left: 10px;
            }
            /deep/ .el-radio:nth-child(1){
                margin-left: 0px;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner {
                border-color: #e7622e;
                background: white;
            }
            /deep/ .el-radio__input.is-checked + .el-radio__label{
                color: #e7622e;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner::after{
                transform: translate(-50%,-50%) scale(2);
                background-color: #e7622e;
            }
        }
    }
}
</style>